/*
 * Collection Toolbar — filter toggle, grid toggle, infinite scroll / load more.
 */

(function () {
  'use strict';

  /* ===== Filter sidebar toggle ===== */
  function initFilterToggle() {
    var btn = document.querySelector('.collection-toolbar__filter-toggle');
    if (!btn) return;

    var container = document.getElementById('CollectionContainer');
    if (!container) return;

    // Default to hidden unless user has explicitly shown them
    if (localStorage.getItem('mc-filters-visible') !== 'true') {
      btn.setAttribute('aria-expanded', 'false');
      container.classList.add('filters-hidden');
      var textEl = btn.querySelector('.collection-toolbar__filter-toggle-text');
      if (textEl) textEl.textContent = textEl.dataset.showText;
    }

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      container.classList.toggle('filters-hidden', expanded);
      var textEl = btn.querySelector('.collection-toolbar__filter-toggle-text');
      if (textEl) {
        textEl.textContent = expanded ? textEl.dataset.showText : textEl.dataset.hideText;
      }
      localStorage.setItem('mc-filters-visible', String(!expanded));
    });
  }

  /* ===== Grid size toggle ===== */
  function setGridColumns(cols) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.className = grid.className.replace(/grid--\d+-col-desktop/g, 'grid--' + cols + '-col-desktop');
    document.querySelectorAll('.collection-toolbar__grid-btn').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.gridColumns === String(cols));
    });
  }

  function initGridToggle() {
    var toggle = document.querySelector('.collection-toolbar__grid-toggle');
    if (!toggle) return;

    var saved = localStorage.getItem('mc-grid-columns');
    if (saved) setGridColumns(saved);

    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-grid-columns]');
      if (!btn) return;
      setGridColumns(btn.dataset.gridColumns);
      localStorage.setItem('mc-grid-columns', btn.dataset.gridColumns);
    });
  }

  function reapplyGridColumns() {
    var saved = localStorage.getItem('mc-grid-columns');
    if (saved) setGridColumns(saved);
  }

  /* ===== Infinite scroll / Load more ===== */
  var scrollHandler = null;

  function getSectionId() {
    var grid = document.getElementById('product-grid');
    return grid ? grid.dataset.id : '';
  }

  function cleanupScrollHandler() {
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
  }

  function initInfiniteScroll() {
    cleanupScrollHandler();

    var container = document.querySelector('.collection-infinite');
    if (!container) return;

    var nextUrl = container.dataset.nextUrl;
    if (!nextUrl) return;

    var loadBtn = container.querySelector('.collection-infinite__btn');
    var spinner = container.querySelector('.collection-infinite__spinner');
    var loading = false;

    function loadNextPage() {
      var url = container.dataset.nextUrl;
      if (!url || loading) return;
      loading = true;
      if (spinner) spinner.classList.remove('hidden');
      if (loadBtn) loadBtn.classList.add('hidden');

      var sectionId = getSectionId();
      var fetchUrl = url;
      if (sectionId) {
        fetchUrl += (url.indexOf('?') !== -1 ? '&' : '?') + 'section_id=' + sectionId;
      }

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Network response ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('#product-grid .grid__item');
          var grid = document.getElementById('product-grid');

          if (grid && newItems.length > 0) {
            newItems.forEach(function (item) {
              grid.appendChild(item);
            });
          }

          // Check for next page
          var newContainer = doc.querySelector('.collection-infinite');
          if (newContainer && newContainer.dataset.nextUrl) {
            container.dataset.nextUrl = newContainer.dataset.nextUrl;
            if (loadBtn) loadBtn.classList.remove('hidden');
          } else {
            container.dataset.nextUrl = '';
            container.classList.add('hidden');
            cleanupScrollHandler();
          }

          loading = false;
          if (spinner) spinner.classList.add('hidden');
          reapplyGridColumns();
        })
        .catch(function (err) {
          console.error('[CT] Fetch error:', err);
          loading = false;
          if (spinner) spinner.classList.add('hidden');
          if (loadBtn) loadBtn.classList.remove('hidden');
        });
    }

    // For infinite scroll, use a scroll listener that checks proximity to page bottom.
    // This is more reliable than IntersectionObserver in complex flex layouts.
    var trigger = container.querySelector('.collection-infinite__trigger');
    if (trigger) {
      scrollHandler = function () {
        if (loading) return;
        var rect = container.getBoundingClientRect();
        // Load when the container is within 800px of the viewport bottom
        if (rect.top < window.innerHeight + 800) {
          loadNextPage();
        }
      };

      window.addEventListener('scroll', scrollHandler, { passive: true });
      // Check immediately in case we're already near the bottom
      scrollHandler();
    }

    // Load more button
    if (loadBtn) {
      loadBtn.addEventListener('click', loadNextPage);
    }
  }

  /* ===== Hook into Dawn's facet re-render ===== */
  function observeGridContainer() {
    var target = document.getElementById('ProductGridContainer');
    if (!target) return;

    var observer = new MutationObserver(function () {
      reapplyGridColumns();
      initInfiniteScroll();
    });

    observer.observe(target, { childList: true });
  }

  /* ===== Init ===== */
  function init() {
    initFilterToggle();
    initGridToggle();
    initInfiniteScroll();
    observeGridContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
